import * as _ from 'lodash';
import Console from 'sos-common/js/utils/console.log';
import { ValidationState } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';

import getValidationStepsMap from './validationOrderSteps';

export function validateStepsByValidationResults(
  state: ValidationState,
  hasHitSummary: boolean = false
): ValidationState {
  const { validationResults, stepValidationMap, touchedFields, fullValidationResults } = state;
  let newstepValidationMap = { ...stepValidationMap };

  newstepValidationMap = _.each(newstepValidationMap, (item) => {
    item.isValid = validateStepByValidationResults(fullValidationResults, item.stepId);
  });

  const filteredValidationResults = filterValidationResultsToShow(fullValidationResults, touchedFields, hasHitSummary);

  return {
    ...state,
    validationResults: filteredValidationResults,
    stepValidationMap: newstepValidationMap,
  };
}

function filterValidationResultsToShow(
  validationResults: ValidationResult[],
  touchedFields: string[] = [],
  hasHitSummary: boolean = false
): ValidationResult[] {
  return validationResults.filter((val) => {
    const fieldName = val.FieldName.replace('CurrentResearchOrder.', '').replace('StatisticsOrder.', '');
    const isTouched = touchedFields.some(
      (f) => f.replace('CurrentResearchOrder.', '').replace('StatisticsOrder.', '') === fieldName
    );
    Console.log(`isFiltering: ${fieldName}, hasHitSummary: ${hasHitSummary}, isTouched: ${isTouched}`);
    return hasHitSummary || isTouched;
  });
}

function validateStepByValidationResults(
  validationResults: ValidationResult[],
  stepId: number,
  touchedFields: string[] = [],
  hasHitSummary: boolean = false
): boolean {
  const fieldsInsteps = getValidationStepsMap();
  const formFields = fieldsInsteps[stepId].fieldNames;

  // need to return if isValid on step..
  for (let i = 0; i < formFields.length; i++) {
    const element = formFields[i];
    const fieldName = element.replace('CurrentResearchOrder.', '').replace('StatisticsOrder.', '');
    if (!validationResults) {
      return true;
    }
    const fieldHasError = validationResults.some((v) => v.FieldName === fieldName);
    // const fieldIsTouched = touchedFields.some(f => f === fieldName);

    if (fieldHasError) {
      return false;
    }
  }
  return true;
}
